/**
 * Created by Jerker Nord on 2019-03-12.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Timeline, TimelineLite, TimelineMax, TweenLite} from "gsap";
import {AnimatedMeshRope} from "../bezieranimation/AnimatedMeshRope";
import {TextureHelper} from "../bezieranimation/TextureHelper";
import {WinterHoardLayerConfig} from "../../config/WinterHoardLayerConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {WinterHoardBetlineNumber} from "../betlinenumber/WinterHoardBetlineNumber";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {WinterHoardGameConfig} from "../../WinterHoardGameConfig";

export class BuffaloWinlinesView extends BaseView {

    private _layer: ScalableLayer;
    private _lineNumberLayer: PIXI.Container;
    private _isPortrait: boolean = false;
    private _betLinesData: number[][];
    private _winLines: AnimatedMeshRope[];
    private _winLinesAdded: number[];
    private _fixedTextures: PIXI.Texture [];
    private _initAnimations: boolean = false;
    private _betLineNumbers: WinterHoardBetlineNumber[];


    constructor() {
        super();
        this._layer = StageManager.getLayer(WinterHoardLayerConfig.WIN_LINES.name);
        this._layer.addChild(this);
        this._lineNumberLayer = new PIXI.Container();
        this.addChild(this._lineNumberLayer);
        this._winLines = [];
        this._winLinesAdded = [];

    }



    protected addEventListeners(): void {
        EventHandler.addEventListener(this, BetLineEvent.SHOW_STATIC_BET_LINE, (event: GameEvent) => this.showStaticWinLine(event.params[0]));
    }

    public disableBetlineNumbers():void {
        this._betLineNumbers.forEach((blNumber) => {
            blNumber.disable();
        });
    }

    protected initAnimations(): void {
        this._initAnimations = true;
        this._fixedTextures = TextureHelper.removeBaseTextures(GameResources.getTextures("winEnergy"));
        if (this._betLinesData) {
            this.createWinLines();
            //this.testAllLines();
            this.disableBetlineNumbers();
        }

        // TODO: Make temp toggling of betlines
    }



    private testAllLines(): Timeline {
        const tl: TimelineMax = new TimelineMax({
            repeat: -1
        });

        tl.add(() => {
        }, "5.0");
        for (let x = 0; x < 40; x++) {
            tl.add(this.getWinlineTL(x, "").play(), "+=0.5");
        }
        //tl.add(this.getCleanUpWinlinesTL());

        return tl;
    }

    public setupToggle(betWins: number []): Timeline {
        const tl: TimelineMax = new TimelineMax({
            repeat: -1
        });

        tl.add(() => {
        }, "5.0");
        for (let x = 0; x < 40; x++) {
            tl.add(this.getWinlineTL(x, "").play(), "+=0.5");
        }
        //tl.add(this.getCleanUpWinlinesTL());

        return tl;
    }

    protected onResize(resizeData: IResizeData): void {
        if (resizeData.orientation === Orientation.LANDSCAPE) {
            this._isPortrait = false;
            this.scale.set(0.92, 0.92);
            this.y = -30;
            this.x = 40;
            this._lineNumberLayer.visible = true;
            this._lineNumberLayer.scale.set(0.98, 0.98);
            this._lineNumberLayer.y = 13;
            this._lineNumberLayer.x = -2;
        } else {
            //this._lineNumberLayer.visible = false;
            this._isPortrait = true;
            this.scale.set(1, 1);
            this.y = -20;
            this.x = 0;
        }
    }

    private createWinLines(): void {
        this._betLineNumbers = [];
        for (let i: number = 0; i < this._betLinesData.length; i++) {
            const betLineNumber: WinterHoardBetlineNumber = new WinterHoardBetlineNumber(i + 1, this._lineNumberLayer);
            const betLineNumberPosition: number[] = betLineNumber.setPosition(this._betLinesData.length);
            this._betLineNumbers.push(betLineNumber);
            let curvePoints: number[][] = [];

            //debugger;
            for (let j: number = 0; j < this._betLinesData[i].length; j++) {
                const positions:[number, number] = Helper.getSymbolPositions(j, this._betLinesData[i][j]);
                positions[0] = positions[0] - 27.5;
                curvePoints.push(positions);
            }


            this.createWinLine(curvePoints);
        }
    }

    private createWinLine(curvePoints: number[][]): void {
        const animatedMeshRope: AnimatedMeshRope = new AnimatedMeshRope();
        animatedMeshRope.createAnimatedMeshRope(this._fixedTextures, curvePoints);
        this._winLines.push(animatedMeshRope);
    }

    public getWinlineTL(winLine: number, winVal:string): Timeline {
        const winLineTL: TimelineLite = new TimelineLite({});
        if (this._winLinesAdded.indexOf(winLine) == -1) {
            this._winLinesAdded.push(winLine);
            winLineTL.add(() => (this.addChild(this._winLines[winLine])));
        }
        winLineTL.add([
            () => {
                //if (!this._isPortrait) { // TODO: FLAG
                if (!WinterHoardGameConfig.instance.WIN_BELOW_STAKE) {
                    this._betLineNumbers[winLine].showIndividualNumber(winLine, winVal)
                }
                //}
            },
            this._winLines[winLine].getAnimatedMeshRopeTL()]);
        winLineTL.add(() => this._betLineNumbers[winLine].showNormal(), 0.8);
        return winLineTL;
    }

    public getCleanUpWinlinesTL(): Timeline {
        const cleanUpWinLinesTL: TimelineLite = new TimelineLite();
        cleanUpWinLinesTL.add(() => {
            this.removeChildren();
            this._winLinesAdded = [];
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
        });
        return cleanUpWinLinesTL;
    }

    set betLinesData(value: number[][]) {
        this._betLinesData = value;
        if (this._initAnimations == true && this._winLines.length == 0) {
            this.createWinLines();
        }
    }

    private showStaticWinLine(winLine: number): void {
        this.addChild(this._winLines[winLine - 1]);
        this._winLines[winLine - 1].getAnimatedMeshRopeTL();
    }
}